import React from 'react';
import { Box, Button } from '@mui/material';

export default function InsertPanel({
  onOpenImage,
  onOpenTable,
  onOpenShape,
  onOpenDivider,
  onOpenTextBox,
  onOpenInsertPage,
  onOpenPageNumber,
  onInsertPageBreak,
}) {

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
      <Button 
        variant="contained"
        onClick={onOpenImage}
        sx={{ 
          width: '100%',
          background: '#D4AF37',
          color: '#1A1A1A',
          fontWeight: 600,
          fontSize: '0.875rem',
          textTransform: 'uppercase',
          borderRadius: '8px',
          padding: '12px 24px',
          '&:hover': {
            background: '#F5D76E',
          }
        }}
      >
        IMAGE
      </Button>
      <Button 
        variant="contained"
        onClick={onOpenTable}
        sx={{ 
          width: '100%',
          background: '#D4AF37',
          color: '#1A1A1A',
          fontWeight: 600,
          fontSize: '0.875rem',
          textTransform: 'uppercase',
          borderRadius: '8px',
          padding: '12px 24px',
          '&:hover': {
            background: '#F5D76E',
          }
        }}
      >
        TABLE
      </Button>
      <Button 
        variant="contained"
        onClick={onOpenShape}
        sx={{ 
          width: '100%',
          background: '#D4AF37',
          color: '#1A1A1A',
          fontWeight: 600,
          fontSize: '0.875rem',
          textTransform: 'uppercase',
          borderRadius: '8px',
          padding: '12px 24px',
          '&:hover': {
            background: '#F5D76E',
          }
        }}
      >
        SHAPE
      </Button>
      <Button 
        variant="contained"
        onClick={onOpenDivider}
        sx={{ 
          width: '100%',
          background: '#D4AF37',
          color: '#1A1A1A',
          fontWeight: 600,
          fontSize: '0.875rem',
          textTransform: 'uppercase',
          borderRadius: '8px',
          padding: '12px 24px',
          '&:hover': {
            background: '#F5D76E',
          }
        }}
      >
        DIVIDER
      </Button>
      <Button 
        variant="contained"
        onClick={onOpenTextBox}
        sx={{ 
          width: '100%',
          background: '#D4AF37',
          color: '#1A1A1A',
          fontWeight: 600,
          fontSize: '0.875rem',
          textTransform: 'uppercase',
          borderRadius: '8px',
          padding: '12px 24px',
          '&:hover': {
            background: '#F5D76E',
          }
        }}
      >
        TEXT BOX
      </Button>
      <Button
        variant="contained"
        onClick={onOpenInsertPage}
        sx={{
          width: '100%',
          background: '#D4AF37',
          color: '#1A1A1A',
          fontWeight: 600,
          fontSize: '0.875rem',
          textTransform: 'uppercase',
          borderRadius: '8px',
          padding: '12px 24px',
          '&:hover': {
            background: '#F5D76E',
          }
        }}
      >
        PAGE
      </Button>
      <Button
        variant="contained"
        onClick={onInsertPageBreak}
        sx={{
          width: '100%',
          background: '#D4AF37',
          color: '#1A1A1A',
          fontWeight: 600,
          fontSize: '0.875rem',
          textTransform: 'uppercase',
          borderRadius: '8px',
          padding: '12px 24px',
          '&:hover': {
            background: '#F5D76E',
          }
        }}
      >
        PAGE BREAK
      </Button>
      <Button
        variant="contained"
        onClick={onOpenPageNumber}
        sx={{ 
          width: '100%',
          background: '#D4AF37',
          color: '#1A1A1A',
          fontWeight: 600,
          fontSize: '0.875rem',
          textTransform: 'uppercase',
          borderRadius: '8px',
          padding: '12px 24px',
          '&:hover': {
            background: '#F5D76E',
          }
        }}
      >
        PAGE NUMBER
      </Button>
    </Box>
  );
}
